import * as Yup from 'yup';
export const initialCoachValues = {
    areaOfOperation: '',
    secondaryAreaOfOperation: '',
    startDate: new Date() || undefined,
    signingSignature: undefined,
};
export const coachSchema = Yup.object().shape({
    areaOfOperation: Yup.string(),
    secondaryAreaOfOperation: Yup.string(),
    startDate: Yup.date(),
    signingSignature: Yup.string(),
    sendInvite: Yup.bool(),
});
//# sourceMappingURL=coach.js.map